

import React, { useState, useEffect } from "react"
import { ReactComponent as BtnRound } from "../../svg/btnRRound.svg";
import { ReactComponent as PaginationRoundBtn } from "../../svg/pginationRound.svg";
import events from "../../store/events";
import { observer } from "mobx-react-lite";

const Events = observer((props) => {
    //console.log(props);
    const [imageFull, setImageFull] = useState(null);

    const setImage = (url) => {
        setImageFull(url);
    }
    useEffect(() => {
        if (imageFull !== null) {
            document.body.style.overflowY = "hidden";
        } else {
            document.body.style.overflowY = "scroll";

        }
    }, [imageFull]);
    const dateTimeFormat = new Intl.DateTimeFormat('ru', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    const scrollTop = () => {
        /*  window.scrollTo({top: 0, behavior: 'smooth'}); */
    }
    const renderMembers = (members) => {
        return (
            <>
            {
                members.map((member) => {
                    if (typeof member!== 'undefined' && typeof member.media !== 'undefined' && member.media.length>0) {
                        return (<div class="item " data={member.id} key={member.id}>
                           
                            <img src={member.media[0].low} alt={member.name}  onClick={() => { setImageFull(member.media[0].hi) }}/>
                        </div>)
                    }
                    else if(typeof member!== 'undefined' )   {
                        return (<div class="item" key={member.id}>
                            <img src={"/assets/img/no_img.png"} alt={member.name}  />
                        </div>)
                    }

                })
            }
            </>
        );
    }
    const renderItems = (members) => {
        return (
            <>
            {
                members.map((member) => {
                    if (typeof member.img !== 'undefined') {
                        return (<div class="item " data={member.id} key={member.id}>

                            <img src={member.img} alt={member.alt} />
                        </div>)
                    }
                    else if (typeof member.low !== 'undefined') {
                        return (<div class="item" key={member.low}>
                            <img src={member.low} alt={member.alt} onClick={() => { setImageFull(member.hi) }} />
                        </div>)
                    }
                    else
                    {
                        return <div>fFF</div>
                    }

                })
            }
            </>
        );
    }
    const getTargetGallery = (galleries, galleryName) => {
        const res = galleries.filter((gal) => gal.name === galleryName)

        if (res.length > 0) return res[0].items;
        return [];
    }
    const renderPage = (page) => {
        return (<div class="slider-content">

            <div class="data_header">
                <h3>{page.name}</h3>
                <div class="date">{dateTimeFormat.format(new Date(page.start_at))}</div>
            </div>
            <div class="data_body" dangerouslySetInnerHTML={{ __html: page.text }}>

            </div>
            <div class="data_navi">
                <div>
                    {page.members != null && page.members.length > 0 && <h4>Участники</h4>}
                    <div class="members">
                        {page.members != null && page.members.length > 0 && renderMembers(page.members)}
                    </div>
                </div>

                <div class="awards">
                    {page.galleries != null && page.galleries.length > 0 && renderItems(getTargetGallery(page.galleries, "awards"))}

                </div>
            </div>
            <div class="data_gallery">
                <div class="media">

                    {page.galleries != null && page.galleries.length > 0 && renderItems(getTargetGallery(page.galleries, "media"))}

                </div>
                <div class="navi">
                    <button class="arrow_left visible-mobile"><BtnRound class="round-arrow rotate-180" onClick={() => events.goPrewItem()} /></button>
                    <button class="arrow_right visible-mobile"><BtnRound class="round-arrow" onClick={() => events.goNextItem()} /></button>
                    {events.getLoading && <p>Загрузка...</p>}
                    {/*  <button class="active"><PaginationRoundBtn /></button>
                    <button class=" "><PaginationRoundBtn /></button>
                    <button class=" "><PaginationRoundBtn /></button> */}
                </div>
            </div>

        </div>);
    } 

    return (
        <div className={props.className + ' event-slider'} >
            <div className={"fullscreenImg " + (imageFull !== null ? 'show' : 'hidden')}>
                <div className="close" onClick={() => { setImageFull(null) }}>X</div>
                <img src={imageFull} alt="" />
            </div>
            {typeof events.page !== 'undefined' ? (<>
                <button class="arrow_left unvisible-mobile" onClick={() => events.goPrewItem()} > <BtnRound class="round-arrow rotate-180" /></button>
                {renderPage(events.page)}

                <button class="arrow_right unvisible-mobile"><BtnRound class="round-arrow" onClick={() => events.goNextItem()} /></button>

                </>
            ) : (
                    <></>
                )}



        </div>
    );
})

export default Events;
